export default {"betButtonWrapper":"_10oRh","betButton":"OEI7N","isSelected":"Gyzs4"};